export const mmToPixels = (mm: number, dpi: number): number => {
    const mmPerInch = 25.4;
    return (mm * dpi) / mmPerInch;
};

export const pixelsToMm = (pixels: number, dpi: number): number => {
    const mmPerInch = 25.4;
    return (pixels * mmPerInch) / dpi;
};

export const inchesToMm = (inches: number): number => {
    return inches * 25.4;
};

export const mmToInches = (mm: number): number => {
    return mm / 25.4;
};

// EMU UNITS
export const pptxUnitsToPixels = (pptxUnit: number, dpi = 300): number => {
    return (pptxUnit / 914400) * dpi;
};

export const pptxFontSizeToPixels = (pptxFontSize: number, dpi = 300): number => {
    return (pptxFontSize / 100) * (dpi / 72);
}
